import { RegexValidators } from '../regexValidators';
export const isPasswordValid = (value) => {
    if (!value)
        return false;
    if (!RegexValidators.HAS_DIGIT.test(value))
        return false;
    if (!(RegexValidators.HAS_LOWER_CASE_LETTERS.test(value) &&
        RegexValidators.HAS_UPPER_CASE_LETTERS.test(value)))
        return false;
    // if (!RegexValidators.HAS_SYMBOL.test(value)) return false;
    return true;
};
//# sourceMappingURL=validators.js.map